


















































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwTitlePane } from '@sonicwall/unified-ui-framework/src/shared/sw-title-pane';
import UUIFComponent from '@/shared/uuifComponent';
import { MswApiService } from '@/shared/msw-api-service';
import { InfoState } from '@/core';
import { SwTable, TableEntry, TableColumnConfig, SortedColumnInfo, ColumnSortRequestData } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { CreateElement, VNode } from 'vue';
import { MswAppTitle }  from '@/shared/msw-app-title';

const cssPrefix = 'snbPromotions';

@Component({
  components: {
    ...UUIFComponent,
    SwTitlePane,
    SwTable,
    MswAppTitle,
  },
  directives: {},
})

export default class SandboxPromotions extends SwExtendedVue {
  cssPrefix = cssPrefix;
  apiResponse: any = '';
  mainTableData: TableEntry[] = [];
  applicablePromotions: any = '';
  appliedPromotions: any = '';
  sortedColumns: SortedColumnInfo[] = [];
  get tableColConfig(): TableColumnConfig[] {
    return [
      {
        key: 'promoDesc',
        dataKey: 'promoDesc',
        title: this.$t('myPromotions.promotion')
        .toString(),
        sorter: true,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div>
              <a style="font-weight: bold" onClick={() => this.handlePromotionClick(data.entry)}>{ data.entry.promoDesc }</a>
            </div>
          ) as VNode;
        },
      },
      {
        key: 'endDate',
        dataKey: 'endDate',
        title: this.$t('myPromotions.validity')
        .toString(),
        sorter: true,
      },
      {
        key: 'upgradeDesc',
        dataKey: 'upgradeDesc',
        title: this.$t('myPromotions.desc')
        .toString(),
        sorter: true,
      },
    ];
  }

  handlePromotionClick(item: any) {
    console.warn(item);
    // @ts-ignore
    window.open(item.promoURL, '_blank')
    .focus();
  }

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  getPromotions() {
    this.$store.commit('startLoading');
    MswApiService.promotions.getPromotions()
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      this.apiResponse = resp.content;
      this.setTableData();
      this.checkApplicablePromotions();
      this.checkPromotionsHistory();
    });
  }

  setTableData() {
    this.mainTableData = this.apiResponse.activePromotions.map((el: any, index: any) => {
      return {
        _key: index,
        promoDesc: el.promoDesc,
        endDate: el.endDate,
        upgradeDesc: el.upgradeDesc,
        promoURL: el.promoURL,
      };
    });
  }

  handlePromoHistory(item: any) {
    this.$router.push({ path: `/m/feature/promotionHistory?data=${item.prodUpgradeTypeID}&snbuser=${this.getSnbUserName()}` });
  }

  handleapplicableHistory(item: any) {
    console.warn(this.applicablePromotions);
    this.$router.push({ path: `/m/feature/applicablePromotions?data=${item.prodUpgradeTypeID}&snbuser=${this.getSnbUserName()}` });
  }

  getSnbUserName() {
    return this.$route.query.snbuser;
  }

  checkApplicablePromotions() {
    if (this.apiResponse.applicablePromotions[0].status) {
      this.applicablePromotions = this.apiResponse.applicablePromotions[0].status;
    } else {
      this.applicablePromotions = this.apiResponse.applicablePromotions;
    }
  }

  checkPromotionsHistory() {
    if (this.apiResponse.appliedPromotions[0].status) {
      this.appliedPromotions = this.apiResponse.appliedPromotions[0].status;
    } else {
      this.appliedPromotions = this.apiResponse.appliedPromotions;
    }
  }

  mounted() {
    this.getPromotions();
  }

  showMessage(infoType: string, infoMsg: string) {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }
}
